import INotification from "../models/INotification";
import { request } from "./ApiService";

export const deleteNotification = async (notificationId: string): Promise<INotification> => request(`notifications/${notificationId}`, { method: "DELETE" });
export const getNotifications = () => request("notifications");
export const toggleNotificationRead = async (notificationId: string): Promise<INotification> => request(`notifications/${notificationId}/toggleread`, { method: "PUT" });
